import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-add-scouting-info-modal',
  templateUrl: './add-scouting-info-modal.component.html',
  styleUrls: ['./add-scouting-info-modal.component.scss'],
})
export class AddScoutingInfoModalComponent extends BaseModal implements OnInit {

  constructor(private modalService: ModalService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private translateService: TranslateService) {
    super()
    super._modalService = modalService
    // this.demoArray = new Array(2).fill(1).map(t => 1)

  }

  ngOnInit() {
    super.ngOnInit()
   }
  dismissModal() {
    super.dismiss({}, '');
  }


}
